import { Component, OnInit, Inject, Optional } from '@angular/core';
import { Absence } from 'src/app/_model/Absence';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import {RequestService} from "../../_services/request.service";
import {WfCompleteRequest} from "../../_model/request/WfCompleteRequest";
import {Requests} from "../../_model/Requests";

@Component({
    selector: 'app-requestsComplete',
    templateUrl: './requestsComplete.component.html',
    styleUrls: ['./requestsComplete.component.css'],
    standalone: true,
        imports: [
            MatDialogModule
        ]
})
export class RequestsCompleteComponent implements OnInit {
    request: WfCompleteRequest = new WfCompleteRequest();
    currentUser: User;

    constructor(public dialogRef: MatDialogRef<RequestsCompleteComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Requests,
                private requestService: RequestService,
                private authService: AuthenticationService,
                private toastr: ToastrService) {
        this.currentUser = this.authService.currentUserValue;
    }

    ngOnInit() {
    }

    completeSelected(requests: Requests) {

        this.request.id = requests.id;
        this.requestService.completeRequests(this.request).subscribe(result => {
            this.toastr.success('Tamamlama işlemi başarılı', '');
            this.dialogRef.close(true);
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
            this.dialogRef.close(false);
        });
    }
}







